module.exports = __webpack_public_path__ + "static/media/about_us.04c34ed2.png";